
import React, { useState, useEffect } from 'react';
import { getCookie, setCookie } from 'stash/utils/cookies';

const tokenNames = {
	accessTokenCookieName: 'stashAccessToken',
	refreshTokenCookieName: 'stashRefreshToken',
	uuidCookieName: 'stashUUID',
};

interface NativeAuthProviderProps {
	children: React.ReactNode;
}

export const NativeAuthProvider = ({ children }: NativeAuthProviderProps) => {
    const [auth, setAuth] = useState({
		accessToken: decodeURIComponent(getCookie(tokenNames.accessTokenCookieName) || ''),
		refreshToken: getCookie(tokenNames.refreshTokenCookieName),
		uuid: getCookie(tokenNames.uuidCookieName),
	});

	useEffect(() => {
		auth.accessToken && setCookie(tokenNames.accessTokenCookieName, encodeURIComponent(auth.accessToken));
		auth.uuid && setCookie(tokenNames.uuidCookieName, auth.uuid);
		auth.refreshToken && setCookie(tokenNames.refreshTokenCookieName, auth.refreshToken);
	}, [auth]);

	// Expose global function for native to refresh access tokens periodically
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	window.setAccessToken = (accessToken: string) => {
		console.log('NativeAuth Client :: setAccessToken func called')
		setAuth({
			...auth,
			accessToken,
		});
	};

	return (
		<>{children}</>
	);
};
